import React, { useState } from 'react';
import { constants } from '../../../misc/constants';
import { setFocus } from '../../../misc/tools';
import GeneralNeutralStatePart1 from '../../../scenarios/general/neutral-state/parts/GeneralNeutralStatePart1';
import { BaseConfig } from '../../BaseConfig';
import GeneralButtonWithText from '../../helpers/GeneralButtonWithText';
import { UIProperties } from '../../UIProperties';

var scaleX = 1;

const VortexUI = (props: UIProperties<VortexUIConfig>) => {
	const [showVortex, setShowVortex] = useState(false);
	const generate508Text = () => {
		var text = 'Vortex ';
		if(!props.parameters.steps) {
			return text;
		}

		var initialText = 'Vortex. The following is the order of attempts. ';
		text = initialText;
		for(var indx = 0; indx < props.parameters.steps.length; indx++) {
			var step = props.parameters.steps[indx];

			switch(indx) {
				case 0:
					text += 'First is ';
					break;
				// case 1:
				// 	text += 'Second is ';
				// 	break;
				case 2:
					text += 'In Third Place is ';
					break;
				// case 3:
				// 	text += 'Fourth is ';
				// 	break;
			}

			switch(step) {
				case VortexUICurrentAttempt.BVM:
					text += 'B V M. which was attempted ' + props.parameters.bvmAttemps + ' time' + (props.parameters.bvmAttemps > 1 ? 's' : '') + '. ';
					break;
				case VortexUICurrentAttempt.ETT:
					text += 'E T T. which was attempted ' + props.parameters.ettAttemps + ' time' + (props.parameters.ettAttemps > 1 ? 's' : '') + '. ';
					break;
				case VortexUICurrentAttempt.SGA:
					text += 'S G A. which was attempted ' + props.parameters.sgaAttemps + ' time' + (props.parameters.sgaAttemps > 1 ? 's' : '') + '. ';
					break;
			}

			if(indx !== props.parameters.steps.length - 1 && indx !== 1) {
				text += ' and then ';
			}
		}
		return text;
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			bottom: '10px',
			left: '10px',
			width: '160px'
		}} tabIndex={0} id={showVortex ? 'vortex-first' : ''} aria-label={generate508Text()}>
			{showVortex ? (
				<div>
					<img src="./assets/images/HUD/Vortex/VORTEX_BG.png"/>
					<div style={{
						opacity: '0.16',
						position: 'absolute',
						top: '0',
						left: '0',
						width: '100%',
						height: '100%'
					}}>
						<div style={{
							position: 'absolute',
							left: '0px',
							top: '0px',
						}}>
							{props.parameters.currentAttempt === VortexUICurrentAttempt.BVM ? <img src="./assets/images/HUD/Vortex/MASK_1.png"/> : (null)}
							{props.parameters.currentAttempt === VortexUICurrentAttempt.ETT ? <img src="./assets/images/HUD/Vortex/MASK_2.png"/> : (null)}
							{props.parameters.currentAttempt === VortexUICurrentAttempt.SGA ? <img src="./assets/images/HUD/Vortex/MASK_3.png"/> : (null)}
						</div>
					</div>
					<div style={{
						position: 'absolute',
						top: '0',
						left: '0',
						width: '100%',
						height: '100%'
					}}>
						{(() => {
							var imgs = [
								null,
								'ARROW_SMALL',
								'ARROW_1',
								'ARROW_2'
							]
							var img = imgs[props.parameters.steps ? props.parameters.steps.length : 0];
							var rotation = 0;

							if(props.parameters.steps) {
								if(props.parameters.steps.length === 2) {
									var currentIndx = props.parameters.steps[props.parameters.steps.length - 1] as number;
									var prevIndx = props.parameters.steps[props.parameters.steps.length - 2] as number;
									if(currentIndx - prevIndx === 1 || (currentIndx === 1 && prevIndx === 3)) {
										scaleX = 1;
									} else {
										scaleX = -1;
									}
								}

								if(props.parameters.steps.length >= 1) {
									var startingPoint = props.parameters.steps[0];
									switch(startingPoint) {
										case VortexUICurrentAttempt.BVM:
											rotation = 0;
											break;
										case VortexUICurrentAttempt.ETT:
											if(scaleX === 1) {
												rotation = 130;
											} else {
												rotation = -130;
											}
											break;
										case VortexUICurrentAttempt.SGA:
											if(scaleX === 1) {
												rotation = -130;
											} else {
												rotation = 130;
											}
											break;
									}
								}
							}

							return img ? (
								<div style={{
									position: 'absolute',
									left: '0px',
									top: '0px',
									transform: 'scaleX('+ scaleX +') rotate(' + rotation + 'deg)'
								}}>
									<img src={'./assets/images/HUD/Vortex/' + img + '.png'}/>
								</div>
							) : (null);
						})()}
						
					</div>
					<p style={{
						position: 'absolute',
						top: '22px',
						left: props.parameters.bvmAttemps > 0 ? '57px' : '66px',
						fontSize: '11pt',
						margin: '0'
					}} className='title-font'><span>BVM</span><span style={{color: 'yellow'}}> {props.parameters.bvmAttemps > 0 ? props.parameters.bvmAttemps : ''}</span></p>
					
					<p style={{
						position: 'absolute',
						top: props.parameters.ettAttemps > 0 ? '88px' : '89px',
						left: props.parameters.ettAttemps > 0 ? '112px' : '109px',
						fontSize: '11pt',
						margin: '0',
						transform: 'rotateZ(-62deg)'
					}} className='title-font'><span>ETT</span><span style={{color: 'yellow'}}> {props.parameters.ettAttemps > 0 ? props.parameters.ettAttemps : ''}</span></p>
					<p style={{
						position: 'absolute',
						top: '89px',
						left: '19px',
						fontSize: '11pt',
						margin: '0',
						transform: 'rotateZ(56deg)'
					}} className='title-font'><span>SGA</span><span style={{color: 'yellow'}}> {props.parameters.sgaAttemps > 0 ? props.parameters.sgaAttemps : ''}</span></p>
				</div>
			): (
				<div>
					<img src="./assets/images/HUD/Vortex/VORTEX_BG_Gray.png"/>
					<GeneralButtonWithText parameters= {{
						text: 'Call for Vortex',
						ariaLbl:'Call for vortex',
						id: 'vortex-first',
						top: '50px',
						left: '-3px',
						width: '165px',
						srcIdle: "./assets/images/HUD/buttons/button_next_main.png",
						srcHighlight: "./assets/images/HUD/buttons/button_next_down.png",
						customMainStyle: {
							// position: 'relative'
						},
						customTextStyle: {
							// color: 'black'
							fontSize: '13pt'
						},
						onClicked: () => {
							const onCallForVortexClicked = (window as any)["onCallForVortexClicked"];
							
							if(constants.isLite && !GeneralNeutralStatePart1.calledForOORam && (window as any)['isCric']) {
								if(onCallForVortexClicked) {
									onCallForVortexClicked();
								}
								return;
							}
							setShowVortex(true);

							if(onCallForVortexClicked) {
								onCallForVortexClicked();
							}
							
							setFocus('vortex-first');
						}
					}}/>
				</div>
			)}
		</div>
	);
};

export interface VortexUIConfig extends BaseConfig {
	currentAttempt: VortexUICurrentAttempt;
	bvmAttemps?: number;
	ettAttemps?: number;
	sgaAttemps?: number;
	steps?: VortexUICurrentAttempt[];
}

export enum VortexUICurrentAttempt {
	None,
	BVM,
	ETT,
	SGA,
	Cric
}

export default VortexUI;